






































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { IBlacklist, IBlacklistSearchParams } from '@/interfaces';
import { dispatchGetBlacklists, dispatchDeleteBlacklist } from '@/store/main/accessors';
import { readHasAdminAccess } from '@/store/main/accessors';
import { format, parseISO } from 'date-fns';

@Component
export default class Blacklists extends Vue {
  public blacklistId: string | null = null;
  public search: string = '';
  public loading: boolean = false;
  public blacklists: IBlacklist[] = [];
  public total: number = 0;

  public range = [];
  public sender: string = '';
  public receiver: string = '';

  public pagination: { sortBy; descending; page; rowsPerPage; footerProps } = {
    sortBy: ['id'],
    descending: [false],
    page: 1,
    rowsPerPage: 20,
    footerProps: { 'items-per-page-options': [10, 20, 50, 100] },
  };

  public async updateBlacklists(clearPagination?: boolean) {
    if (clearPagination) {
      this.pagination.page = 1;
    }
    this.loading = true;
    const data = await this.getDataFromApi();
    this.total = data.total;
    this.blacklists = data.items;
    this.loading = false;
  }

  @Watch('pagination', { deep: true })
  public async onPaginationChange(val) {
    await this.updateBlacklists();
  }

  public get headers() {
    const headers = [
      {
        text: this.$vuetify.lang.t('$vuetify.name'),
        value: 'name',
        align: 'left',
      },
      {
        text: this.$vuetify.lang.t('$vuetify.service'),
        value: 'service',
        align: 'left',
      },
      {
        text: this.$vuetify.lang.t('$vuetify.sender'),
        value: 'sender',
        align: 'left',
      },
      {
        text: this.$vuetify.lang.t('$vuetify.actions'),
        value: 'id',
      },
    ];

    return headers;
  }

  public get hasAdminAccess() {
    return readHasAdminAccess(this.$store);
  }

  public async mounted() {
    await this.updateBlacklists();
  }

  public async getDataFromApi() {
    const { sortBy, descending, page, rowsPerPage } = this.pagination;
    const skip = (page - 1) * rowsPerPage;
    const params: IBlacklistSearchParams = {
      skip,
      limit: rowsPerPage,
      orderBy: sortBy[0],
      descending: descending[0],
      blacklistId: this.blacklistId,
    };
    return await dispatchGetBlacklists(this.$store, params);
  }

  public async deleteBlacklists(id: number) {
    if (confirm(this.$vuetify.lang.t('$vuetify.deleteBlacklistsConfirmation'))) {
      await dispatchDeleteBlacklist(this.$store, id);
      await this.updateBlacklists();
    }
  }

  public getDateFormat(dtStr: string) {
    return format(parseISO(dtStr), `yyyy-MM-dd kk:mm`);
  }
}
